import { render, staticRenderFns } from "./medicine-lab-groups.vue?vue&type=template&id=d07036a0&scoped=true"
import script from "./medicine-lab-groups.vue?vue&type=script&lang=js"
export * from "./medicine-lab-groups.vue?vue&type=script&lang=js"
import style0 from "./medicine-lab-groups.vue?vue&type=style&index=0&id=d07036a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07036a0",
  null
  
)

export default component.exports